// Touch keyboards keep Enter available for line breaks, independently of viewport size.
export const handleChatKeyDown = (event, submit, busy = false) => {
  const native = event.nativeEvent || event;
  if (event.key !== "Enter" || event.shiftKey || event.ctrlKey || event.altKey || event.metaKey ||
      native.isComposing || native.keyCode === 229 || event.repeat ||
      window.matchMedia?.("(hover: none) and (pointer: coarse)").matches) return;
  event.preventDefault();
  if (!busy) submit(event);
};
